<template>
  <!-- 头部 -->
  <div class="head other">
    <div class="wrapper">
      <div class="head-left">
        <router-link to="/" class="h3">
          <img class="logo" :src="logo" alt="" />
        </router-link>
      </div>
      <div class="head-right">
        <el-menu
          :default-active="activerouter"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="true"
          text-color="#E2FAFF"
          v-show="flag"
        >
          <el-menu-item class="item1"  index="/index" style="color:#fff">{{ $t('message.home') }}</el-menu-item>
          <!-- <el-menu-item index="/generalization" v-if="oneTree">{{ $t('message.ABOUTGROUP') }}</el-menu-item>
          <el-menu-item index="/business" v-if="oneTree">{{ $t('message.business') }}</el-menu-item>
          <el-menu-item index="/news" v-if="oneTree">{{ $t('message.news') }}</el-menu-item>
          <el-menu-item index="/us" v-if="oneTree">{{ $t('message.JoinUs') }}</el-menu-item> -->
          <!-- <el-menu-item
            v-for="i in tree"
            :key="i.name"
            @click="getRouter(i.name)"
          >
            <el-dropdown class="navtext">
              <span class="el-dropdown-link">
                {{ i.name }}
              </span>
              <el-dropdown-menu  v-show="twotree1">
                <el-dropdown-item
                  v-for="twotree in i.childList"
                  :key="twotree.name"
                  ><a @click="getTwotree(twotree.templatesId, i.name)">{{
                    twotree.name
                  }}</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-menu-item> -->
          <el-menu-item class="nav">
            <ul class="navItem">
              <li v-for="i in tree"
              :key="i.name"
              @mouseenter="mouseenter"
              class="navItemList"
              @click="getRouter(i.name, i.url)">{{ i.name }}
                <ul class="itemList" id="itemList">
                  <li v-for="twotree in i.childList"
                    :key="twotree.name"  @click.stop="getTwotree(twotree.templatesId, i.name,twotree.url)">
                    <a>{{
                      twotree.name
                      }}
                      <ul class="lastChild">
                        <li v-for="children in twotree.childList"  @click.stop="getLastTree(children.templatesId, i.name,children.url)" :key="children.id">
                          <a>{{children.name}}</a>
                        </li>
                      </ul>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </el-menu-item>
          <!-- <el-menu-item index="/" @click="tz()">{{
            $t('message.InvestorRelations')
          }}</el-menu-item> -->
        </el-menu>
      </div>
      <!-- <button @click="denglu()">登录/注册</button> -->
      <div>
        <el-button-group>
          <el-button type="primary" v-if="!btn" @click="langChange($event,'zh')"
            >Chinese</el-button
          >
          <el-button type="primary" v-if="btn" @click="langChange($event,'en')"
            >English</el-button
          >
        </el-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import { logo, tree, templatesDetail } from '@/api/index.js'
export default {
  data() {
    return {
      flag: true,
      pmwidth: null,
      activerouter: null,
      logo: null,
      btn: true,
      tree: null,
      btn2: '1',
      oneTree: false,
      twotree: null,
      three: null
    }
  },
  mounted() {
    this.getHeader()
    const defaultMenu = window.location.hash.substr(
      window.location.hash.indexOf('/')
    )
    this.activerouter = defaultMenu
    this.getLogo()
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll)
    // 点击空白关闭侧边栏
    this.pmwidth = document.documentElement.clientWidth
    this.pmwidth = document.body.offsetWidth
    window.onresize = () => {
      return (() => {
        this.pmwidth = document.body.offsetWidth
      })()
    }
  },
  methods: {
    mouseenter() {
      // const itemList = document.getElementById('itemList')
      // itemList.style.transform = 'translate(-12%)'
      const itemList = document.querySelectorAll('#itemList')
      for (var i = 0; i < itemList.length; i++) {
        itemList[i].style.transform = 'translate(-12%)'
        if (itemList[i].childElementCount === 3) {
          itemList[i].style.transform = 'translate(-30%)'
        }
      }
    },
    langChange(e, type) {
      this.btn = !this.btn
      if (type === 'zh') {
        this.btn2 = 1
      } else if (type === 'en') {
        this.btn2 = 2
      }
      this.$bus.$emit('lang', type)
      this.$i18n.locale = type
      console.log(type)
      // this.lan = e
      // console.log(this.lan)
      this.getHeader()
    },
    // 获取logo
    async getLogo() {
      await logo({}).then((res) => {
        // console.log(res)
        this.logo = res.data.logo_url
        localStorage.setItem('logo', this.logo)
      })
    },
    handleScroll() {
      // 头部滚动背景色
      const head = document.querySelector('.head')
      if (document.body.clientWidth < 1200) {
        // head.classList.add('head-bg')
      }
      if (window.pageYOffset >= 1) {
        head.classList.add('head-bg')
      } else {
        head.classList.remove('head-bg')
      }
    },
    handleSelect(key, keyPath) {
    },
    denglu() {
      this.$router.push('/login')
    },
    // 获取动态nav
    async getHeader() {
      const { data } = await tree({
        type: this.btn2
      })
      // console.log(data)
      this.tree = data
      if (this.tree !== data) {
        this.oneTree = true
      }
    },
    // nav一级树跳转
    getRouter(e, url) {
      // console.log(e)
      if (e === '投资互动') {
        return window.open('https://ir.p5w.net/c/300008.shtml')
      } else if (url) {
        return window.open(url)
      } else if (this.$router.push !== e) {
        this.$router.push({ name: e })
      }
      this.$emit('getRouter', e, url)
    },
    // nav二级树跳转
    async getTwotree(e, a, url) {
      if (e) {
        // this.twotree1 = true
        const { data } = await templatesDetail(
          {
            id: parseInt(e)
          },
          this.$router.push({
            name: a,
            params: { id: e }
          })
        )
        this.twotree = data.content
        // console.log(this.twotree)
        this.$emit('getTwotree', this.twotree)
      } else if (url) {
        return window.open(url)
      } else {
        this.$router.push('/tohome')
      }
    },
    // nav三级树跳转
    async getLastTree(e, a, url) {
      if (e) {
        const { data } = await templatesDetail(
          {
            id: parseInt(e)
          },
          this.$router.push({
            name: a,
            params: { id: e }
          })
        )
        this.threeTree = data.content
        this.$emit('getThreetree', this.threeTree)
      } else if (url) {
        return window.open(url)
      } else {
        this.$router.push('/tohome')
      }
    }
  },
  watch: {
    pmwidth(val) {
      // console.log(val)
      if (val < 475) {
        document.addEventListener('click', (e) => {
          if (!this.$el.contains(e.target)) {
            this.flag = false
            // console.log(this.flag)
          }
        })
      } else {
        this.flag = true
        // console.log(this.flag)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}
.head {
  position: fixed;
  z-index: 2000;
  top: 0;
  width: 100%;
  // max-width: 1960px;
  height: 40px;
  background-color: #112945;
  opacity: .8;
  color: #E2FAFF;
  overflow: hidden;
  @media screen and (max-width: 1200px) {
    position: fixed;
    z-index: 9999;
    top: 0;
    width: 100%;
    height: 100px;
    background-color: #112945;
  }
   @media screen and (min-width: 1200px) {
      height: 80px;
      background-color: #112945;
    }
  &.head-bg {
    background-color: #112945;
    height: 40px;
    @media screen and (max-width: 1200px) {
      height: 100px;
      background-color: #112945;
    }
    @media screen and (min-width: 1200px) {
      height: 80px;
      background-color: #112945;
    }
  }
  .wrapper {
    height: 100%;
    max-width: 1800px;
    // min-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // @media screen and (max-width: 475px) {
    //   height: 100%;
    //   max-width: 96%;
    //   min-width: 200px;
    //   margin: 0 auto;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    // }
    // @media screen and (max-width: 1600px) {
    //   height: 100%;
    //   max-width: 90%;
    //   min-width: 200px;
    //   margin: 0 auto;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    // }
    .head-left {
      display: flex;
      align-items: center;
      height: 100%;
      @media screen and (max-width: 475px) {
        flex-direction: column;
      }
      .h3 {
        .logo {
          // width: 150px;
          height: 40px;
          margin-right: 10px;
          @media screen and (min-width: 1200px) {
            width: 510px;
            height: 60px;
          }
          @media screen and (max-width: 1200px) {
            width: 510px;
            height: 60px;
          }
        }
        // @media screen and (max-width: 475px) {
        //   width: 100%;
        // }
      }
      p {
        font-size: 15px;
        margin-left: 15px;
        // @media screen and (max-width: 1480px) {
        //   font-size: 16px;
        // }
        // @media screen and (max-width: 1100px) {
        //   font-size: 14px;
        // }
        // @media screen and (max-width: 900px) {
        //   font-size: 12px;
        // }
        //  @media screen and (max-width: 840px) {
        //   display: none;
        // }
        // @media screen and (max-width: 475px) {
        //   display: inline-block;
        //   font-size: 12px;
        //   margin-left: 20px;
        // }
      }
    }
    .head-right {
      display: flex;
      align-items: center;
      height: 100%;
      font-size: 20px;
      .el-menu {
        margin-right: 40px;
        display: flex;
        border: 0;
        // max-width: 580px;
        // @media screen and (max-width: 475px) {
        //   display: flex;
        //   flex-direction: column;
        //   background-color: rgba(0, 0, 0, 0.8);
        //   position: fixed;
        //   top: 60px;
        //   left: 0;
        //   z-index: 20;
        //   width: 150px !important;
        //   height: 100%;
        // }
        .el-menu-item {
          padding: 0 15px;
          flex: 1;
          color: #E2FAFF;
          font-size: 18px!important;
          font-weight: 500;
          cursor: pointer;
          border: none !important;
          @media screen and (max-width: 1200px) {
            font-size: 20px!important;
          }
          @media screen and (max-width: 1200px) {
            font-size: 26px!important;
          }
          // @media screen and (max-width: 1380px) {
          //   font-size: 14px;
          //   padding: 0 6px !important;
          //   flex: none;
          //   height: 70px !important;
          //   width: 70px;
          // }
          // @media screen and (max-width: 475px) {
          //   font-size: 16px;
          //   flex: none;
          //   height: 70px !important;
          //   width: 100px;
          //   margin-left: 20px;
          // }
          &:hover {
            color: rgb(250, 249, 249) !important;
            background-color: transparent !important;
          }
        }
        .el-menu-item:first-child {
            margin-right: 20px;
        }
        .el-menu-item:last-child {
            margin-left: -25px;
        }
      }
    }
    button {
      width: 125px;
      text-align: center;
      height: 50px;
      background-color: #E2FAFF;
      border-radius: 20px;
      border: 0;
      color: #e9510a;
      font-size: 17px;
      margin-left: 20px;
      cursor: pointer;
      @media screen and (max-width: 1200px) {
        width: 140px;
        height: 60px;
      }
    }
    .zykc {
      width: 125px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      background-color: #276ff4;
      border-radius: 20px;
      border: 0;
      color: #fff;
      font-size: 15px;
      margin-left: 20px;
      cursor: pointer;
      // @media screen and (max-width: 1480px) {
      //   width: 100px;
      //   text-align: center;
      //   height: 30px;
      //   line-height: 30px;
      //   background-color: #276ff4;
      //   border-radius: 15px;
      //   border: 0;
      //   color: #fff;
      //   font-size: 12px;
      //   margin-left: 10px;
      //   cursor: pointer;
      // }
      // @media screen and (max-width: 1380px) {
      //   min-width: 80px;
      //   text-align: center;
      //   height: 30px;
      //   line-height: 30px;
      //   background-color: #276ff4;
      //   border-radius: 15px;
      //   border: 0;
      //   color: #fff;
      //   font-size: 12px;
      //   margin-left: 10px;
      //   cursor: pointer;
      // }
      // @media screen and (max-width: 475px) {
      //   position: fixed;
      //   left: 14px;
      //   top: 500px;
      //   z-index: 30;
      // }
    }
    p {
      font-size: 14px;
      margin-left: 50px;
    }
  }
}
.mini {
  display: none;
  // @media screen and (max-width: 475px) {
  //   display: flex;
  //   align-items: center;
  //   width: 70px;
  //   height: 20px;
  // }
  span {
    margin-right: 10px;
  }
  img {
    width: 25px;
    height: 20px;
  }
}
.el-menu {
  background-color: transparent;
  .el-menu-item {
    background-color: transparent !important;
    margin-right: 10px;
  }
}
.navtext{
  span{
    font-size: 16px;
    &:hover{
      color: #f9f9fa;;
    }
  }
}
.nav{
  .navItem{
    display: flex;
    justify-content: center;
    align-items: center;
    li{
      height: 100%;
      color: #fff;
      position: relative;
      padding:0 15px;
      font-size: 18px;
          @media screen and (max-width: 1500px) {
            font-size: 20px;
          }
          @media screen and (max-width: 1200px) {
            font-size: 26px!important;
            padding: 0 20px;
          }
      .itemList{
        display: none;
        flex-direction: column;
        background: #112945;
        position: fixed;
        text-align: center;
      }
      &:hover{
        color: #e9510a;
        .itemList{
          display: block;
        }
      }
    }
  }
}
.itemList {
  li {
      &:hover {
        color: #e9510a;
        ul{
          display: block;
        }
      }
      .lastChild {
        display: none;
        flex-direction: column;
        background: #112945;
        position: absolute;
        left: 100%;
        top: 0;
        text-align: center;
      }
  }
}
</style>
